import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { Languages, Users, Globe, User, LogOut, Shield } from 'lucide-react';
import NotificationBell from '../NotificationBell';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';

export const DashboardHeader = ({ user, onLogout }) => {
  const navigate = useNavigate();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="dashboard-logo">
          <div className="w-10 h-10 rounded-md bg-primary/20 flex items-center justify-center">
            <Languages className="w-5 h-5 text-primary" />
          </div>
          <span className="font-heading text-xl font-semibold text-foreground">
            <span className="text-primary/70">Language</span><span className="text-primary">Constructor</span>
          </span>
        </Link>
        
        <div className="flex items-center gap-4">
          <Button 
            variant="ghost" 
            onClick={() => navigate('/friends')} 
            className="text-foreground-muted hover:text-foreground" 
            data-testid="friends-btn"
          >
            <Users className="w-5 h-5 mr-2" />
            <span className="hidden sm:inline">Friends</span>
          </Button>
          <Button 
            variant="ghost" 
            onClick={() => navigate('/discover')} 
            className="text-foreground-muted hover:text-foreground" 
            data-testid="discover-btn"
          >
            <Globe className="w-5 h-5 mr-2" />
            <span className="hidden sm:inline">Discover</span>
          </Button>
          <NotificationBell />
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" className="flex items-center gap-2" data-testid="user-menu-btn">
                <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center">
                  {user?.picture ? (
                    <img src={user.picture} alt="" className="w-8 h-8 rounded-full" />
                  ) : (
                    <User className="w-4 h-4 text-primary" />
                  )}
                </div>
                <span className="text-foreground-muted hidden sm:block">{user?.name}</span>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="bg-background-paper border-border">
              <DropdownMenuItem 
                onClick={() => navigate('/profile')} 
                className="text-foreground-muted hover:text-foreground cursor-pointer" 
                data-testid="profile-menu-item"
              >
                <User className="w-4 h-4 mr-2" />
                Profile Settings
              </DropdownMenuItem>
              {user?.is_admin && (
                <DropdownMenuItem 
                  onClick={() => navigate('/admin')} 
                  className="text-primary hover:text-primary cursor-pointer" 
                  data-testid="admin-menu-item"
                >
                  <Shield className="w-4 h-4 mr-2" />
                  Admin Panel
                </DropdownMenuItem>
              )}
              <DropdownMenuSeparator />
              <DropdownMenuItem 
                onClick={onLogout} 
                className="text-foreground-muted hover:text-foreground cursor-pointer" 
                data-testid="logout-menu-item"
              >
                <LogOut className="w-4 h-4 mr-2" />
                Sign Out
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
};
